import css from './importantlinks.module.css'

const ImportantLinks = () => {
    return (
        <section className={css.links_wrapper}>
            <h2 className={css.section_title}>Important Links</h2>
            <div className={css.links_list}>
                <div className={css.link}>
                    <i className={`fa-solid fa-link ${css.link_icon}`} />
                    <a href="https://results.upmsp.edu.in/">हाईस्कूल एवं इण्टरमीडिएट परीक्षाओं का परीक्षाफल</a>
                </div>
                <div className={css.link}>
                    <i className={`fa-solid fa-link ${css.link_icon}`} />
                    <a href="https://upmsp.edu.in/">माध्यमिक शिक्षा परिषद, उत्तर प्रदेश, प्रयागराज</a>
                </div>
                <div className={css.link}>
                    <i className={`fa-solid fa-link ${css.link_icon}`} />
                    <a href="http://scholarship.up.gov.in//">उत्तर प्रदेश स्कॉलरशिप ऑनलाइन</a>
                </div>
            </div>
        </section>
    )
}

export default ImportantLinks